/**
 * 通用工具
 */

/** 简单 UUID v4(浏览器与 Cloudflare Workers 都可用) */
export function uuid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // 兜底(Workers 18+ 已支持,此处仅作保险)
  const buf = new Uint8Array(16);
  (crypto as Crypto).getRandomValues(buf);
  buf[6] = (buf[6] & 0x0f) | 0x40;
  buf[8] = (buf[8] & 0x3f) | 0x80;
  const h = Array.from(buf, (b) => b.toString(16).padStart(2, '0'));
  return `${h.slice(0, 4).join('')}-${h.slice(4, 6).join('')}-${h
    .slice(6, 8)
    .join('')}-${h.slice(8, 10).join('')}-${h.slice(10, 16).join('')}`;
}

/** 简单防抖 */
export function debounce<T extends (...args: never[]) => unknown>(
  fn: T,
  ms = 300,
): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return (...args: Parameters<T>) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
}

/** 日期辅助:返回 YYYY-MM-DD */
export function formatDate(ts: number): string {
  const d = new Date(ts);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** 日期时间:YYYY-MM-DD HH:mm(日记/记录主标签) */
export function formatDateTime(ts: number): string {
  const d = new Date(ts);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${day} ${h}:${min}`;
}

/** 按 createdAt 升序计算每条记录的实际序号(1-based,与 day 字段无关) */
export function buildRecordIndexById<T extends { id: string; createdAt: number }>(
  items: readonly T[],
): Map<string, number> {
  const sorted = [...items].sort(
    (a, b) => a.createdAt - b.createdAt || a.id.localeCompare(b.id),
  );
  return new Map(sorted.map((item, i) => [item.id, i + 1]));
}
